module.exports = __webpack_public_path__ + "img/bojin@2x.c451421f.png";